import React from 'react'
import { NavLink } from 'react-router-dom'
import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { Menu, Typography } from 'antd'
import {
  filter,
  first,
  groupBy,
  intersection,
  isEmpty,
  map,
  values,
} from 'lodash'

import { APP_ROUTES } from '../../constants'
import {
  useFilterOnPermission,
  useFirstPathnameSegment,
  useLoggedInUser,
} from '../../hooks'
import { StyledMenu, StyledNavigationBar } from '../styled'

import Logo from './logo'

const navigationTabs = filter(values(APP_ROUTES), 'isNavigationTab')

const renderNavigationTabs = navigationTabs =>
  map(navigationTabs, ({ key, link, name }) => (
    <Menu.Item key={key}>
      <NavLink to={link}>{name}</NavLink>
    </Menu.Item>
  ))

const filterOnPermission = (loggedInUser, elements) => {
  const filteredElements = groupBy(
    filter(
      elements,
      ({ permissions }) =>
        !isEmpty(intersection(loggedInUser?.permissions, permissions)),
    ),
    'key',
  )

  return map(values(filteredElements), element => first(element))
}

const NavigationBar = () => {
  const loggedInUser = useLoggedInUser()
  const selectedKey = useFirstPathnameSegment()

  const navigationTabsOnPermissions = useFilterOnPermission(navigationTabs)

  const nonSubMenuItems = filter(
    navigationTabsOnPermissions,
    ({ subMenuItems }) => isEmpty(subMenuItems),
  )

  const subMenuItems = map(
    filter(
      navigationTabsOnPermissions,
      ({ subMenuItems }) => !isEmpty(subMenuItems),
    ),
    ({ subMenuItems, ...rest }) => ({
      ...rest,
      subMenuItems: filterOnPermission(loggedInUser, subMenuItems),
    }),
  )

  return (
    <StyledNavigationBar>
      <StyledMenu mode="horizontal" selectedKeys={[selectedKey]}>
        <Menu.Item key="logo" disabled>
          <Logo />
        </Menu.Item>
        {map(subMenuItems, ({ key, link, name, subMenuItems }) => (
          <Menu.SubMenu
            key={key}
            title={
              <Menu.Item style={{ padding: 0 }}>
                <NavLink to={link}>{name}</NavLink>
              </Menu.Item>
            }
          >
            {map(
              values(subMenuItems),
              ({ key: subMenuKey, link: subMenuLink, name: subMenuName }) => (
                <Menu.Item key={subMenuKey}>
                  <NavLink to={subMenuLink}>{subMenuName}</NavLink>
                </Menu.Item>
              ),
            )}
          </Menu.SubMenu>
        ))}
        {renderNavigationTabs(nonSubMenuItems)}
      </StyledMenu>
      <StyledMenu mode="horizontal" selectedKeys={[selectedKey]}>
        <Menu.SubMenu key="user-sub-menu" title={<UserOutlined />}>
          <Menu.Item key={APP_ROUTES.SETTINGS.key}>
            <NavLink to={APP_ROUTES.SETTINGS.link}>
              <SettingOutlined /> {APP_ROUTES.SETTINGS.name}
            </NavLink>
          </Menu.Item>
          <Menu.Item key={APP_ROUTES.LOGOUT.key}>
            <NavLink to={APP_ROUTES.LOGOUT.link}>
              <Typography.Text type="danger">
                <LogoutOutlined /> {APP_ROUTES.LOGOUT.name}
              </Typography.Text>
            </NavLink>
          </Menu.Item>
        </Menu.SubMenu>
      </StyledMenu>
    </StyledNavigationBar>
  )
}
export default NavigationBar
